import Cookies from 'js-cookie';

import { getPostHogBootstrapCookieName } from '@/common/constants';

export interface BootstrapCookieValue {
  distinctID?: string;
  sessionID?: string;
}

export function readBootstrapCookie(): BootstrapCookieValue | null {
  const cookieValue = Cookies.get(getPostHogBootstrapCookieName());
  if (!cookieValue) return null;
  try {
    return JSON.parse(cookieValue);
  } catch {
    return null;
  }
}
